<template>
  <div class="container">

    <div>
      <div class="div3">
        <img :src="data.pic" />
      </div>
      <div class="one">{{data.title}}</div>
      <p class="two" v-html="data.content">{{data.content}}</p>
    </div>
  </div>
</template>


<script>
  import {getEnterpriseList} from "../../../api/zoujindaweijia"
  export default {
    name: "Si",
    data(){
      return{
        data:[]
      }
    },
    mounted() {
      getEnterpriseList().then(res=>{
        let data = res.data[3];
        this.data = data;
      })

    }
  }
</script>


<style scoped>
  .container{
  }
  .div3{
    /*position: absolute;*/
    margin-left:22vw ;
    margin-top: 10vw;
  }
  img{
    width: 55vw;
  }
  .one{
    margin-left: 5vw;
    margin-top: 5vw;
    font-size: 3vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #000000;
  }
  .two{
    /*position: absolute;*/
    width: 89vw;
    /*height: 15.9896vw;*/
    font-size: 1.0417vw;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #000000;
    margin-left: 5vw;
    margin-top: 3vw;
    margin-bottom: 10vw;
  }
  /deep/ p {
    font-size: 3vw!important;
    line-height: 4.5vw!important;
    color: black !important;
  }
</style>